var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.547 11.132.3 4.973a1.003 1.003 0 0 1 0-1.433 1.04 1.04 0 0 1 1.453 0L8 9.7l6.246-6.159c.372-.367.96-.394 1.363-.079l.09.08a1.003 1.003 0 0 1 0 1.432l-6.247 6.158.001.001L8 12.565z",
  clipRule: "evenodd"
})));
export { SvgArrowDown as ReactComponent };